import React from 'react'
import { connect } from 'react-redux'
import { updateAddress, expireUpdatedParticipant, cleanError } from 'Participant/ducks'
import Address from 'Participant/Address/Address'
import { actions as addressActions } from 'features/Address'
import { getAddress as getAddressProps } from 'features/Address/reducer'

const mapStateToProps = ({ participant, address }) => getAddressProps({ participant, address })

const mapDispatchToProps = dispatch => ({
  fetchShipping: zipCode => {
    dispatch(addressActions.fetchAddress(zipCode))
  },
  updateParticipant: participant => dispatch(updateAddress(participant)),
  expireUpdatedParticipant: () => dispatch(expireUpdatedParticipant()),
  closeAlert: () => {
    dispatch(addressActions.cleanError())
    dispatch(cleanError())
  }
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(props => <Address {...props} />)



// WEBPACK FOOTER //
// ./src/Participant/Address/AddressPage.js